var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.orderedBlocks.length ? _c('div', {
    staticClass: "simplified-html-view"
  }, [_vm._l(_vm.orderedBlocks, function (block) {
    return _c('div', {
      key: block.id,
      ref: 'block-' + block.id,
      refInFor: true,
      staticClass: "block-item",
      class: ['block-type-' + block.type, 'block-tag-' + block.tag, {
        'block-selected': _vm.selectedBlockId === block.id,
        'block-grouped': block.group,
        'block-hovered-external': _vm.externallyHoveredBlockId === block.id
      }],
      on: {
        "click": function click($event) {
          return _vm.selectBlock(block.id);
        },
        "mouseenter": function mouseenter($event) {
          return _vm.$emit('block-hover', block.id);
        },
        "mouseleave": function mouseleave($event) {
          return _vm.$emit('block-hover', null);
        }
      }
    }, [block.type === 'heading' ? _c('div', {
      staticClass: "block-content"
    }, [_c('span', {
      staticClass: "block-label"
    }, [_vm._v(_vm._s(_vm.blockLabel(block)))]), _c('div', {
      ref: 'editor-' + block.id,
      refInFor: true,
      class: 'editable-heading heading-' + block.tag,
      attrs: {
        "contenteditable": "true"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.sanitizeHtml(_vm.getBlockValue(block.id)))
      },
      on: {
        "blur": function blur($event) {
          return _vm.onHtmlEdit(block.id, $event);
        },
        "keydown": function keydown($event) {
          return _vm.onKeydown(block.id, $event, true);
        }
      }
    })]) : block.type === 'richtext' ? _c('div', {
      staticClass: "block-content"
    }, [_c('span', {
      staticClass: "block-label"
    }, [_vm._v(_vm._s(_vm.blockLabel(block)))]), _c('div', {
      ref: 'editor-' + block.id,
      refInFor: true,
      staticClass: "editable-richtext",
      attrs: {
        "contenteditable": "true"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.sanitizeHtml(_vm.getBlockValue(block.id)))
      },
      on: {
        "blur": function blur($event) {
          return _vm.onHtmlEdit(block.id, $event);
        },
        "keydown": function keydown($event) {
          return _vm.onKeydown(block.id, $event, true);
        }
      }
    })]) : block.type === 'image' ? _c('div', {
      staticClass: "block-content block-image"
    }, [_c('span', {
      staticClass: "block-label"
    }, [_vm._v(_vm._s(_vm.blockLabel(block)))]), _c('div', {
      staticClass: "image-preview"
    }, [_vm.getBlockValue(block.id) && !_vm.failedImages[block.id] ? _c('img', {
      staticClass: "preview-img",
      attrs: {
        "src": _vm.getBlockValue(block.id)
      },
      on: {
        "error": function error($event) {
          return _vm.onImgError(block.id);
        }
      }
    }) : _c('v-icon', {
      attrs: {
        "large": "",
        "color": "grey lighten-1"
      }
    }, [_vm._v("mdi-image-outline")])], 1), _c('div', {
      staticClass: "image-src-row mt-1"
    }, [_c('v-text-field', {
      ref: 'editor-' + block.id,
      refInFor: true,
      attrs: {
        "value": _vm.getBlockValue(block.id),
        "label": _vm.$t('custom_html_block_image_src'),
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      on: {
        "change": function change($event) {
          return _vm.onFieldEdit(block.id, $event);
        }
      },
      nativeOn: {
        "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
          return _vm.onFieldKeydownEnter(block.id, $event);
        }
      }
    }), _vm.isAllowed('gallery_view') ? _c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "icon": "",
              "color": "primary"
            },
            on: {
              "click": function click($event) {
                $event.stopPropagation();
                return _vm.openGallery(block.id);
              }
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-image-outline")])], 1)];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('cmstool_select_image_gallery')))])]) : _vm._e()], 1)]) : block.type === 'text' && block.group && block.group.startsWith('a_') ? _c('div', {
      staticClass: "block-content"
    }, [_c('span', {
      staticClass: "block-label"
    }, [_vm._v(_vm._s(_vm.blockLabel(block)))]), _c('v-text-field', {
      ref: 'editor-' + block.id,
      refInFor: true,
      attrs: {
        "value": _vm.getBlockValue(block.id),
        "label": _vm.$t('custom_html_block_link_text'),
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      on: {
        "change": function change($event) {
          return _vm.onFieldEdit(block.id, $event);
        }
      },
      nativeOn: {
        "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
          return _vm.onFieldKeydownEnter(block.id, $event);
        }
      }
    })], 1) : block.type === 'url' ? _c('div', {
      staticClass: "block-content"
    }, [_c('span', {
      staticClass: "block-label"
    }, [_vm._v(_vm._s(_vm.blockLabel(block)))]), _c('v-text-field', {
      ref: 'editor-' + block.id,
      refInFor: true,
      attrs: {
        "value": _vm.getBlockValue(block.id),
        "label": _vm.$t('custom_html_block_link_url'),
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      on: {
        "change": function change($event) {
          return _vm.onFieldEdit(block.id, $event);
        }
      },
      nativeOn: {
        "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
          return _vm.onFieldKeydownEnter(block.id, $event);
        }
      }
    })], 1) : _c('div', {
      staticClass: "block-content"
    }, [_c('span', {
      staticClass: "block-label"
    }, [_vm._v(_vm._s(_vm.blockLabel(block)))]), _c('div', {
      ref: 'editor-' + block.id,
      refInFor: true,
      staticClass: "editable-text",
      attrs: {
        "contenteditable": "true"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.sanitizeHtml(_vm.getBlockValue(block.id)))
      },
      on: {
        "blur": function blur($event) {
          return _vm.onHtmlEdit(block.id, $event);
        },
        "keydown": function keydown($event) {
          return _vm.onKeydown(block.id, $event, true);
        }
      }
    })]), _c('v-btn', {
      staticClass: "block-delete-btn",
      attrs: {
        "icon": "",
        "x-small": ""
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.deleteBlock(block);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "x-small": "",
        "color": "grey"
      }
    }, [_vm._v("mdi-delete-outline")])], 1)], 1);
  }), _c('select-image-dialog', {
    attrs: {
      "display-select-image-dialog": _vm.activeGalleryBlockId !== null,
      "app-tags": ['stc-editor-image'],
      "isAllowedEdit": _vm.isAllowed('gallery_edit')
    },
    on: {
      "update:displaySelectImageDialog": _vm.closeGallery,
      "gallery-selected": _vm.onGallerySelected
    }
  })], 2) : _c('div', {
    staticClass: "simplified-html-empty pa-6"
  }, [_c('div', {
    staticClass: "template-picker"
  }, [_c('h3', {
    staticClass: "picker-title mb-4"
  }, [_vm._v(_vm._s(_vm.$t('custom_html_template_picker_title')))]), !_vm.isEnglishReference ? _c('v-alert', {
    staticClass: "template-language-warning text-body-2",
    attrs: {
      "type": "warning",
      "text": "",
      "dense": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('custom_html_template_non_english_warning')) + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'config-global',
        query: {
          editLanguage: '1'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('custom_html_template_change_language_link')))])], 1) : _vm._e(), _c('div', {
    staticClass: "template-cards"
  }, _vm._l(_vm.templates, function (template) {
    return _c('div', {
      key: template.id,
      staticClass: "template-card",
      class: {
        disabled: !_vm.isEnglishReference
      },
      on: {
        "click": function click($event) {
          _vm.isEnglishReference && _vm.$emit('template-selected', template.html);
        }
      }
    }, [_c('v-icon', {
      staticClass: "template-icon mb-2",
      attrs: {
        "color": "primary"
      }
    }, [_vm._v(_vm._s(template.icon))]), _c('div', {
      staticClass: "template-name font-weight-bold"
    }, [_vm._v(_vm._s(_vm.$t(template.nameKey)))]), _c('div', {
      staticClass: "template-desc grey--text"
    }, [_vm._v(_vm._s(_vm.$t(template.descKey)))])], 1);
  }), 0), _c('div', {
    staticClass: "text-center mt-4"
  }, [_c('a', {
    staticClass: "scratch-link grey--text text-caption",
    on: {
      "click": function click($event) {
        return _vm.$emit('start-scratch');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('custom_html_template_picker_or_scratch')) + " ")])])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }